"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

require("./LoadingIcon.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LoadingIcon = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LoadingIcon, _Component);

  var _super = (0, _createSuper2.default)(LoadingIcon);

  function LoadingIcon() {
    (0, _classCallCheck2.default)(this, LoadingIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LoadingIcon, [{
    key: "render",
    value: function render() {
      var size = this.props.size || 80;
      var className = "loading-icon-container";
      var loadingHeader;
      var loadingMessage;

      if (this.props.centered) {
        className += " loading-icon-centered";
      }

      if (this.props.header) {
        loadingHeader = /*#__PURE__*/_react.default.createElement("div", {
          className: "loading-header-container"
        }, /*#__PURE__*/_react.default.createElement("h4", null, this.props.header));
      }

      if (this.props.message) {
        loadingMessage = /*#__PURE__*/_react.default.createElement("div", {
          className: "loading-message-container"
        }, /*#__PURE__*/_react.default.createElement("p", null, this.props.message));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: size + "px",
        height: size + "px",
        viewBox: "0 0 80 80"
      }, /*#__PURE__*/_react.default.createElement("path", {
        className: "threeskye-loading-icon-outer-ring",
        d: "M40,78.9A38.9,38.9,0,1,1,78.9,40,38.94,38.94,0,0,1,40,78.9Zm0-68.33A29.43,29.43,0,1,0,69.43,40,29.46,29.46,0,0,0,40,10.57Z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        className: "threeskye-loading-icon-inner-ring",
        d: "M74.16,44.73A4.73,4.73,0,0,1,69.43,40,29.46,29.46,0,0,0,40,10.57,4.74,4.74,0,0,1,40,1.1,38.94,38.94,0,0,1,78.9,40,4.74,4.74,0,0,1,74.16,44.73Z"
      }, /*#__PURE__*/_react.default.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 40 40",
        to: "360 40 40",
        dur: "0.8s",
        repeatCount: "indefinite"
      }))), loadingHeader, loadingMessage);
    }
  }]);
  return LoadingIcon;
}(_react.Component);

var _default = LoadingIcon;
exports.default = _default;